class Copromote {
    constructor(el) {
        var that = this;

        this.copromoteBox = $('div.co-promote');
        this.copromoteBox.find('.item').each(function() {
            var item = $(this);

            item.find('a.btn').bind('click', function() {
                var button = $(this);

                if(item.data('type') == 'invite') {
                    if(button.hasClass('btn-primary')) {
                        that.acceptInvite(item.data('invite-id'));
                    }
                    else {
                        that.declineInvite(item.data('invite-id'));
                    }
                }
                // else {
                //     if(button.hasClass('btn-primary')) {
                //         that.acceptRequest(item.data('id'));
                //     }
                //     else {
                //         that.declineRequest(item.data('id'));
                //     }
                // }

                return false;
            });
        });
    }

    acceptInvite(inviteId) {
        var that = this;

        profile.acceptCopromoteInvite(inviteId, function() {
            if(that.copromoteBox) {
                var item = that.copromoteBox.find('.item[data-type="invite"]').filter('[data-invite-id="' + inviteId + '"]');

                if(item.length) {
                    item.find('a.btn').remove();
                    item.find('.result').removeClass('declined').addClass('accepted');

                    window.setTimeout(function() {
                        window.location.href = window.location.pathname;
                    }, 500);
                }
            }
        });
    }

    declineInvite(inviteId) {
        var that = this;

        profile.declineCopromoteInvite(inviteId, function() {
            if(that.copromoteBox) {
                var item = that.copromoteBox.find('.item[data-type="invite"]').filter('[data-invite-id="' + inviteId + '"]');

                if(item.length) {
                    item.find('a.btn').remove();
                    item.find('.result').removeClass('accepted').addClass('declined');
                }
            }
        });
    }

    acceptRequest(requestId) {
        // var that = this;

        // profile.acceptCopromoteRequest(requestId, function() {
        //     if(that.copromoteBox) {
        //         var item = that.copromoteBox.find('.item[data-type="request"]').filter('[data-id="' + requestId + '"]');

        //         if(item.length) {
        //             item.find('a.btn').remove();
        //             item.find('.result').removeClass('declined').addClass('accepted');
        //         }
        //     }
        // });
    }

    declineRequest(requestId) {
        // var that = this;

        // profile.declineCopromoteRequest(requestId, function() {
        //     if(that.copromoteBox) {
        //         var item = that.copromoteBox.find('.item[data-type="request"]').filter('[data-id="' + requestId + '"]');

        //         if(item.length) {
        //             item.find('a.btn').remove();
        //             item.find('.result').removeClass('accepted').addClass('declined');
        //         }
        //     }
        // });
    }
}

export { Copromote }
